module.exports = __webpack_public_path__ + "media/metronic/_theme/media/client-logos/logo2-b5e8f4958632e22df8725c6cd449a95a.png";